module.exports = __webpack_public_path__ + "img/icon3.98220a47.png";